export const SELF_CONTROL_REQUEST_GET_REQUEST =
  "SELF_CONTROL_REQUEST_GET_REQUEST";
export const SELF_CONTROL_REQUEST_GET_SUCCESS =
  "SELF_CONTROL_REQUEST_GET_SUCCESS";
export const SELF_CONTROL_REQUEST_GET_ERROR =
  "SELF_CONTROL_REQUEST_GET_ERROR";
export const SELF_CONTROL_REQUEST_GET_BY_KEY_REQUEST =
  "SELF_CONTROL_REQUEST_GET_BY_KEY_REQUEST";
export const SELF_CONTROL_REQUEST_GET_BY_KEY_SUCCESS =
  "SELF_CONTROL_REQUEST_GET_BY_KEY_SUCCESS";
export const SELF_CONTROL_REQUEST_GET_BY_KEY_ERROR =
  "SELF_CONTROL_REQUEST_GET_BY_KEY_ERROR";
export const SELF_CONTROL_REQUEST_ADD_REQUEST =
  "SELF_CONTROL_REQUEST_ADD_REQUEST";
export const SELF_CONTROL_REQUEST_ADD_SUCCESS =
  "SELF_CONTROL_REQUEST_ADD_SUCCESS";
export const SELF_CONTROL_REQUEST_ADD_ERROR =
  "SELF_CONTROL_REQUEST_ADD_ERROR";
export const SELF_CONTROL_REQUEST_EDIT_REQUEST =
  "SELF_CONTROL_REQUEST_EDIT_REQUEST";
export const SELF_CONTROL_REQUEST_EDIT_SUCCESS =
  "SELF_CONTROL_REQUEST_EDIT_SUCCESS";
export const SELF_CONTROL_REQUEST_EDIT_ERROR =
  "SELF_CONTROL_REQUEST_EDIT_ERROR";
export const SELF_CONTROL_REQUEST_DELETE_REQUEST =
  "SELF_CONTROL_REQUEST_DELETE_REQUEST";
export const SELF_CONTROL_REQUEST_DELETE_SUCCESS =
  "SELF_CONTROL_REQUEST_DELETE_SUCCESS";
export const SELF_CONTROL_REQUEST_DELETE_ERROR =
  "SELF_CONTROL_REQUEST_DELETE_ERROR";

export const SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_REQUEST =
  "SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_REQUEST";
export const SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_SUCCESS =
  "SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_SUCCESS";
export const SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_ERROR =
  "SELF_CONTROL_REQUEST_WORKFLOW_UPDATE_ERROR";
